import React, { useState, useEffect } from 'react'
import Layout from '../Layout'
import { useSelector } from 'react-redux'
import Container from '../components-layout/Container'
import WarningModal from '../components-modals/WarningModal'
import Header from '../components-layout/Header'
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline'
import ContrasenaGrid from './components/ContrasenaGrid'
import RecepcionGrid from '../recepcion-proveedores/components/RecepcionGrid'
import Cookies from 'universal-cookie'
const ContrasenaIndex = () => {
    const user = useSelector(state => state.auth.user) 
    const userObj = JSON.parse(user)
    const [loading, setLoading] = useState(false)
    const [textos, setTextos] = useState([])
    const [modal, setModal] = useState({
        show: false,
        msg: '',
        ok: false,
    });
    const columnas = [
        { name: 'Id', id: 0, type: 'text', resaltado: false },
        { name: 'Nombre', id: 1, type: 'text', resaltado: false },
        {
            name: "Acciones",
            id: 999,
            type: "text",
            resaltado: false,
            text: "Seleccionar",
            alt: "Editar",
          },
    ]

    const handleAlumnos = (...props) => {
        console.log(props)
    }
    const handleClick = (...props) => {
        console.log(props)
    }
    const handleChangeTextbox = (e, Idx) => { // handleGridInput handleChangeTextbox
        console.log(e.target.name)

      setTextos({
        ...textos,
        [e.target.name]: parseInt(e.target.value || 0),
      });
  };

  return (
    <Layout
      userObj={userObj}
      activeTab='contrasena-conta'
    >
            <WarningModal
                open={loading ? true : false}
                image={<img src='./img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />

            <WarningModal
                open={modal.show ? true : false}
                image={
                    modal.ok 
                        ? <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto"/>
                        : <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto"/>
                }
                title='Aviso'
                subtitle={<span>{modal.msg}</span>}
                opacity='bg-opacity-50'
            >
                <div className="mt-5 sm:mt-6">
                <button
                    onClick={() => {
                        if(modal.ok){
                            window.location.reload()
                        }
                        setModal(curr => ({
                            ...curr, show: false
                        }))
                    }}
                    type="button"
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                >
                    Entendido
                </button>
                </div>
            </WarningModal>
            <Container height='h-full'>
                <Header
                    title="Contraseñas conta"
                    logo={CheckCircleIcon}
                />
                <ContrasenaGrid
                                handleChangeTextbox={handleChangeTextbox}
                                filteredData={[{id:1, name:'d', registrado: 0, recibido: 0}, {id:2, name:'e', registrado: 0, recibido: 0}, {id:3, name:'adsf', registrado: 0,recibido: 0}, {id:4, name:'eqwrewr', registrado: 0, recibido: 0}]}
                />
                {/*
                <RecepcionGrid
                    alumnos={[{id:1, name:'d'}, {id:2, name:'e'}, {id:3, name:'adsf'}, {id:4, name:'eqwrewr'}]}
                    seleccion={true}
                    columnas={columnas}
                    handleAlumno={handleAlumnos}
                    handleClick={handleClick}
                    titulo='Desglose de contraseñas por proveedor'
                    subtitulo='Detalle de pagos'
                />
                */}
            </Container>
        
    </Layout>
  )
}

export default ContrasenaIndex